import { render, staticRenderFns } from "./BankList.vue?vue&type=template&id=b6cde942&scoped=true"
import script from "./BankList.vue?vue&type=script&lang=js"
export * from "./BankList.vue?vue&type=script&lang=js"
import style0 from "./BankList.vue?vue&type=style&index=0&id=b6cde942&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cde942",
  null
  
)

export default component.exports